import { useEffect, useRef, useState } from 'react'
import './player-market-landing.styles.scss'
import { changeDocumentTitle } from '@/utils/useDocumentTitle';
import { Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import PlayerStore from './player-store.component';
import ImageContainer from '@/components/SHARED/image-container/image-container.component';
import StoreButtons from './store-components/store-buttons.component';
import { useSelector } from 'react-redux';
import { getGameElementsFromDb } from '@/utils/getDataFromDb';
import ShoppingCart from './shopping-cart.component';
import { completeGameElementData } from '@/components/PREVIEW/previewGameElements';

const PlayerMarketLanding = ({
  gameData,
  gameElements,
  playerData,
  gameStats,
  teamMembers,
  myTeams,
  unadjustedPlayerData
}) => {

  const location = useLocation();
  const { hash } = location;
  const navigate = useNavigate();
  const screenSize = useSelector(state => state.contentData.screenSize);
  const [itemType, setItemType] = useState(hash ? hash.replace('#', '') : 'inventory');
  const [availableItems, setAvailableItems] = useState([]);
  const [collections, setCollections] = useState([]);
  const [saleList] = useState([]);
  const collectionRef = useRef();
  const marketRef = useRef([]);
  const collectionListenerRef = useRef();
  const marketListenerRef = useRef();

  const gameId = gameData?.gameId;
  const isPreview = location.pathname.includes('/preview/player/')

  useEffect(() => {
    if (!hash) return;
    setItemType(hash.replace('#', ''));
  }, [hash])

  // keep the #type anchor in the url in sync with the chosen tab
  function chooseItemType(type) {
    setItemType(type);
    navigate({ 'hash': type }, { 'replace': true });
  }

  useEffect(() => {
    if (!gameData?.gameName) return;
    const pageTitle = document.getElementById('page-title');
    if (pageTitle) {
      pageTitle.innerText = 'Shop the Marketplace'
    }
    changeDocumentTitle(`Marketplace | ${gameData?.gameName}`);
  }, [gameData?.gameName]);


  useEffect(() => {
    if (!gameId) return;
    // console.log(gameElements)
    // if (!gameElements || !gameData) return;

    // const availItems = Object.values(gameElements)
    // .filter(e => 
    //     (
    //         e.type === 'item' || 
    //         e.type === 'prizePack'
    //     ) && 
    //     e.status === 'active' && 
    //     e.opt_visible &&
    //     e.opt_market 
    // );
    // setAvailableItems(availItems);
    // console.log(availItems);
    getCollections();
    getMarketItems();

    function getCollections() {
      if (!gameId) return;
      if (isPreview) {
        const collectionsObj = {}; 
        Object.values(completeGameElementData)
          .filter(a => 
            a.type === 'collection' && 
            a.status === 'active' &&
            a.opt_visible
          )
          .forEach(c => {
            collectionsObj[c.id] = c;
          });
        setCollections(Object.values(collectionsObj));
        return;
      }
      getGameElementsFromDb({
        "gameId": gameId,
        "elementType": "collection",
        "status": "active",
        "callback": callback,
        "handleListener": handleListener
      })
      function callback(data) {
        collectionRef.current = {
          ...collectionRef.current,
          ...{ [data.id]: data }
        }
        setCollections(Object.values(collectionRef.current));
      }
      function handleListener(unsub) {
        collectionListenerRef.current = unsub;
      }
    }

    function getMarketItems() {
      if (isPreview) {
        const marketObj = {}; 
        Object.values(completeGameElementData)
          .filter(a => 
            a.type === 'item' && 
            a.status === 'active' &&
            a.opt_visible &&
            a.opt_market
          )
          .forEach(c => {
            marketObj[c.id] = c;
          });
        setAvailableItems(Object.values(marketObj));
        return;
      }

      getGameElementsFromDb({
        "gameId": gameId,
        "elementType": "item",
        "market": true,
        "status": "active",
        "callback": callback,
        "handleListener": handleListener
      })
      function callback(data) {
        marketRef.current = {
          ...marketRef.current,
          ...{ [data.id]: data }
        }
        setAvailableItems(Object.values(marketRef.current));
      }
      function handleListener(unsub) {
        marketListenerRef.current = unsub;
      }
    }
    return () => {
      if (collectionListenerRef.current) collectionListenerRef.current();
      if (marketListenerRef.current) marketListenerRef.current();
    }
  }, [gameId, isPreview])

  useEffect(() => {
    if (!gameElements) return;
    getSales();
    function getSales() {
      // const now = new Date().getTime();
      // setSaleList(
      //     Object.values(gameElements)
      //     .filter(e => 
      //         e.type === 'sale' &&
      //         e.status === 'active' &&
      //         (!e.opt_dateOpen || e.opt_dateOpen < now) &&
      //         (!e.opt_dateClose || e.opt_dateClose > now)
      //     )
      //     .sort((a,b) => a.ts > b.ts ? 1 : -1)
      // )
    }
    
  }, [gameElements]);



  return (
    <div className={`player-market ${screenSize}`}>
      <Routes>
        <Route path='' element={
          <div className='g-card market-card'>
            {/* <BackButton cancel={() => navigate(-1)} /> */}
            <div className='player-title'>
              <ImageContainer src='/images/icons/shopping-cart.png' alt='marketplace icon' className='player-title-icon' />
              Shop the Marketplace
            </div>
            <hr />
            <div className='market-grid'>
              <div className='button-col'>
                {
                  (availableItems && gameData) &&
                  <StoreButtons
                    allItems={availableItems}
                    setItemType={chooseItemType}
                    itemType={itemType}
                    gameData={gameData}
                    skipInitialType={!!hash}
                  />
                }
              </div>
              <div className='player-market-content'>
                <PlayerStore
                  gameData={gameData}
                  playerData={playerData}
                  availableItems={availableItems}
                  itemType={itemType}
                  gameStats={gameStats}
                  teamMembers={teamMembers}
                  saleList={saleList}
                  collections={collections}
                />

              </div>
              {/* {
                                (screenSize === 'mobile' || screenSize === 'tablet') &&
                                <div className='buttons'>
                                    <button className='g-button primary'>
                                        Go To Cart
                                    </button>
                                </div>
                            } */}
            </div>
          </div>
        }></Route>
        <Route path='shoppingcart' element={
          <ShoppingCart
            gameData={gameData}
            playerData={playerData}
            gameElements={availableItems}
            gameStats={gameStats}
            teamMembers={teamMembers}
            myTeams={myTeams}
            unadjustedPlayerData={unadjustedPlayerData}
          />
        }></Route>

      </Routes>

    </div>
  )
}

export default PlayerMarketLanding;